import { reactive } from 'vue';

export const AlertType = Object.freeze({
  ALERT: 'ALERT',
  CONFIRM: 'CONFIRM',
});

export const alertState = reactive({
  isVisible: false,
  title: '',
  message: '',
  type: AlertType.ALERT,
  resolve: null,
  reject: null,
});

export function showCustomAlert({ title = '', message = '', type = AlertType.ALERT }) {
  return new Promise((resolve, reject) => {
    alertState.title = title;
    alertState.message = message;
    alertState.type = type;
    alertState.resolve = resolve;
    alertState.reject = reject;
    alertState.isVisible = true;
  });
}

export function confirmAlert() {
  alertState.isVisible = false;
  alertState.resolve?.();
  clear();
}

export function cancelAlert() {
  alertState.isVisible = false;
  alertState.reject?.();
  clear();
}

function clear() {
  alertState.resolve = null;
  alertState.reject = null;
}
